import { Pipe, PipeTransform } from '@angular/core';

import { lancamentos } from '../../../models';

@Pipe({
    name: 'lancamento'
})
export class LancamentoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = lancamentos.findIndex(lancamento => lancamento.id === value);
        if (index > -1) {
            return lancamentos[index].nome;
        }
        return '';
    }
}
